import { createContext, useContext } from "react";

/** The organization whose settings are shown. The shared settings pages read it to pick their API. */
const Scope = createContext("");

export const ScopeProvider = Scope.Provider;
export const useScope = () => useContext(Scope);

/** An organization's administration API path. */
export const adminPath = (org: string, path: string) => `/v1/orgs/${encodeURIComponent(org)}${path}`;

/** An organization's webhook app registry path. */
export const appsPath = (org: string, path = "") => `/v1/orgs/${encodeURIComponent(org)}/apps${path}`;
